import { FC, Ref } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import CustomTable from './_CustomTable'

interface Props {
  schemas: EmployeeCustomTablesSchemaFragment[]
  resources?: Resource[]
  values?: Value[]
  attachableId: number
  attachableType: string
  schemaRefs: Ref<HTMLElement>[]
  currency: string
  canManage: boolean
  canAddValues: boolean
}

const ListComponent: FC<Props> = ({
  schemas,
  resources,
  values,
  attachableId,
  attachableType,
  schemaRefs,
  currency,
  canManage,
  canAddValues,
}) => (
  <>
    {schemas.map((schema, key) => {
      if (schema.fields.length === 0) return null

      const schemaResource = resources?.find((r) => r.get('schema_id') === schema.id)
      let schemaValues: Value[] | undefined = []

      if (schemaResource) {
        schemaValues = values?.filter((v) => v.get('resource_id') === schemaResource.attributes.id)
      }

      return (
        <Box key={key} ref={schemaRefs[key]} paddingTop="s16" paddingBottom="s80">
          <CustomTable
            key={key}
            currency={currency}
            schema={schema}
            resource={schemaResource}
            values={schemaValues}
            attachableId={attachableId}
            attachableType={attachableType}
            canManage={canManage}
            canAddValues={canAddValues}
          />
        </Box>
      )
    })}
  </>
)

export default observer(ListComponent)
